// extracted by mini-css-extract-plugin
module.exports = {"main":"feed_main__3rniw","link":"feed_link__1zqUC","name":"feed_name__1h1jA","scroll":"feed_scroll__2omXm"};